export const modifiedApp = {
  id: 101,
  name: "modified",
  label: "modified eCommerce",
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/modified.svg",
  // "migration" = initial data import (products from the shop into Connect), which modified does
  // not offer. "reporting" has no flows on the preset either.
  areaBlacklist: ["migration", "reporting"],
  // The REST API of modified is a separate add-on and every call needs a bearer token, so the
  // credential check posts the login form itself: a 200 from /api/v1/oauth means the account exists
  // and has API access, a 401 means it does not. The urlencoded content type is what makes the
  // connection check send the credentials as form fields.
  additional_params: {
    requestHeaders: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    requestMethod: "POST",
    endpoint: "/api/v1/oauth"
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_MODIFIED_PRESET_ID,
    testWorkflows: {
      product: process.env?.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      salesOrder: process.env?.VUE_APP_SCM_APP_MODIFIED_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_MODIFIED_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID
    }
  }
};
